// Amplify
import { fetchAuthSession } from "aws-amplify/auth";

// Cache is shared because we can have only one active auth domain at a time
let authSession = {
  authorizationHeader: null,
  expiresAt: null,
};

const isExpired = () => {
  if (!authSession.expiresAt) return true;
  return Date.now() >= authSession.expiresAt;
};

const buildRequestOptions = (token) => {
  if (!token) return {};

  return { headers: { Authorization: token } };
};

export const cacheAuthSessionOptions = (session) => {
  const idToken = session?.tokens?.idToken;
  authSession = {
    authorizationHeader: idToken?.toString() || null,
    expiresAt: idToken?.payload?.exp ? idToken.payload.exp * 1000 : null,
  };

  return buildRequestOptions(authSession.authorizationHeader);
};

export const refreshApiSession = async () => {
  const session = await fetchAuthSession();

  return cacheAuthSessionOptions(session);
};

export const getApiSessionOptions = async () => {
  if (!authSession.authorizationHeader || isExpired()) {
    await refreshApiSession();
  }

  return buildRequestOptions(authSession.authorizationHeader);
};

export const clearApiSession = () => {
  authSession = {
    authorizationHeader: null,
    expiresAt: null,
  };
};
